/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedRoleMappingService } from '../../services/wealthlane-identity-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../../services/wealthlane-award-services';

const useDeleteAllowedRoleMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse | undefined,
  any,
  string,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: string) => {
      return await handleRequest(
        AllowedRoleMappingService.deleteApiIdentityApiAppAllowedRoleMapping(id)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          void queryClient.invalidateQueries('getAllowedRoleMappings');
          toast.success(
            <ToastComponent label='Success' message={`Allowed Role Mapping Deleted.`} />
          );
        }
        closeModal();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useDeleteAllowedRoleMapping;
